import { render, staticRenderFns } from "./WorkflowStateDetailOptionButton.vue?vue&type=template&id=a4fef7c0&"
import script from "./WorkflowStateDetailOptionButton.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateDetailOptionButton.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowStateDetailOptionButton.vue?vue&type=style&index=0&id=a4fef7c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports